import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import List from './routes/List';
import Edit from './routes/Edit';

const Requests = ({match}) => (
	<div>
		<Switch>
			<Route exact path={`${match.url}`} component={ List } />
			<Route path={`${match.url}/:id`} component={ Edit } />
		</Switch>
	</div>
);

export default Requests;


// WEBPACK FOOTER //
// ./app/used/requests/index.js